import { usePatientStore } from "../../../hooks";

export const PatientSurgeryResultsTable = () => {
  // Datos del hook ----------------------------------------//
  const {
    // Props
    patientSurgery,
  } = usePatientStore();

  const {
    track = null,
    dasiScore = null,
    mets = null,
    cRisk = null,
    asa = null,
    Cfs = null
  } = patientSurgery.data;

  const evaluationFirst = patientSurgery?.data?.evaluations?.EVALUATION?.[0];
  const allergiesQuestion = evaluationFirst?.questions?.find(
    (item) => item.id === "fc8cd907-ed7d-11f0-bea3-066d180a3717"
  );
  const allergies = allergiesQuestion?.followUpQuestion?.value ?? null;

  // States ------------------------------------------------//
  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//

  return (
    <div className="table-responsive shadow border-0">
      <table className="table">
        <thead className="table-primary">
          <tr>
            <th className="border-bottom p-3">Indicador</th>
            <th className="border-bottom p-3">Resultado</th>
          </tr>
        </thead>
        <tbody>
          {track !== null && (
            <tr>
              <td className="p-3">Riesgo</td>
              <td className="p-3">{track}</td>
            </tr>
          )}
          {dasiScore !== null && (
            <tr>
              <td className="p-3">Dasi Score</td>
              <td className="p-3">{dasiScore}</td>
            </tr>
          )}
          {mets !== null && (
            <tr>
              <td className="p-3">Mets</td>
              <td className={`p-3 ${mets >= 4 ? "text-underline-success" : "text-underline-danger" }`}>{mets}</td>
            </tr>
          )}
          {cRisk !== null && (
            <tr>
              <td className="p-3">Riesgo cardiovascular</td>
              <td className={`p-3 ${cRisk <= 6 ? "text-underline-success" : "text-underline-danger" }`}>{cRisk}</td>
            </tr>
          )}
          {Cfs !== null && (
            <tr>
              <td className="p-3">Escala de fragilidad</td>
              <td className="p-3">{Cfs}</td>
            </tr>
          )}
          {allergies !== null && (
            <tr>
              <td className="p-3">Alergias</td>
              <td className="p-3">{allergies}</td>
            </tr>
          )}
          {asa !== null && (
            <tr>
              <td className="p-3">Clasificación ASA</td>
              <td className="p-3">{asa}</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};
